export { REPEAT_ORDER_KEY as REORDER_KEY, repeatOrderIntoCart as reorderIntoCart, type RepeatOrderResult as ReorderResult } from '@eliadmin/core/src/utils/repeat-order';

export const REORDER_LABEL = 'Znova objednať';
